import { SignedIn, SignedOut } from "@clerk/clerk-react";
import { Suspense } from "react";
import { Navigate, Outlet } from "react-router";
import { RouteFallback } from "./RouteFallback";
import { Sidebar } from "./Sidebar";

export function AppShell() {
  return (
    <>
      <SignedOut>
        <Navigate to="/login" replace />
      </SignedOut>
      <SignedIn>
        <div className="flex h-screen overflow-hidden bg-background text-foreground">
          <Sidebar />
          <main className="flex-1 overflow-y-auto">
            {/* Inner Suspense boundary: a lazy page chunk suspends HERE, so the
                sidebar/shell stays mounted and only the content area shows the
                fallback during navigation. */}
            <Suspense fallback={<RouteFallback />}>
              <Outlet />
            </Suspense>
          </main>
        </div>
      </SignedIn>
    </>
  );
}
